module.exports = __webpack_public_path__ + "img/urny1.40705c15.jpg";